import { Injectable, inject } from '@angular/core';

import { RouteTag } from '@frontend/sports/common/core/data-access/route';
import { RouterEventsService } from '@frontend/sports/common/core/utils/router-events';
import { FreshDataProvider, FreshDataType } from '@frontend/sports/data-refresh/feature';
import { MediaQueryService } from '@frontend/vanilla/core';
import { Observable, Subject, distinctUntilChanged, map, skip } from 'rxjs';

import { LARGE_LAYOUT_BREAKPOINT, MEDIUM_LAYOUT_BREAKPOINT } from './media-breakpoint.model';

@Injectable({ providedIn: 'root' })
export class LayoutRefreshProvider extends FreshDataProvider {
    private media = inject(MediaQueryService);

    private reloadNeededStream = new Subject<FreshDataType>();

    // as we are using differnet breakpoints for the responsive column, we need different breakpoints for widget pages
    private readonly widgetBreackpoints = [LARGE_LAYOUT_BREAKPOINT, MEDIUM_LAYOUT_BREAKPOINT];
    private readonly baseBreakpoints = ['gt-md', 'gt-xs'];

    private widgetPage = false;

    constructor() {
        const router = inject(RouterEventsService);

        super();

        // TODO: REFACTOR MODULA DEPENDENCY
        router.currentActivationEnd.subscribe((event) => {
            this.widgetPage = [RouteTag.Lobby, RouteTag.SportLobby, RouteTag.Competition, RouteTag.MultiSportsLobby].includes(
                event?.snapshot.data['tag'],
            );
        });

        this.media
            .observe()
            .pipe(
                map(() => this.activeBreakpoint()),
                distinctUntilChanged(),
                skip(1),
            )
            .subscribe(() => {
                this.reloadNeededStream.next(FreshDataType.Data);
            });
    }

    isRefreshNeeded(): Observable<FreshDataType> {
        return this.reloadNeededStream.asObservable();
    }

    private activeBreakpoint = () =>
        this.widgetPage ? this.findActiveBreakpoint(this.widgetBreackpoints) : this.findActiveBreakpoint(this.baseBreakpoints);

    private findActiveBreakpoint = (breakpoints: string[]) => breakpoints.find((breakpoint) => this.media.isActive(breakpoint)) || '';
}
